enum PlatformTaskFilterQueryMode {
    NONE = 'NONE',
    JUMP_TO_TASK = 'JUMP_TO_TASK',
}

export default PlatformTaskFilterQueryMode;
